import { Component, ComponentFactoryResolver, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef, ApplicationRef, Injector, ComponentRef, ReflectiveInjector } from '@angular/core';
import { CampoAggiuntivo, CampoUtility } from "../models/campo-aggiuntivo";
import { Permission } from "../../Login/_guards/Permission";
import { ToastrService } from "ngx-toastr";
import { ApiPathsService } from "../../api-paths.service";
import { AngularEditorConfig } from "../../../LibrerieCustom/angular-editor/src/public-api";
import { Prodotto } from "../../Progetti/Models/Prodotto";
import { SignaturePad } from 'angular2-signaturepad';
import { DynamicEditComponent } from '../dynamic-edit/dynamic-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ActionButton } from '../_services/dynamic-crud.service';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import {Router} from "@angular/router";
import {
  ListaInterventiOffertaComponent
} from "../../Interventi/lista-interventi-offerta/lista-interventi-offerta.component";
import {DomSanitizer} from "@angular/platform-browser";
import {ca} from "date-fns/locale";

@Component({
  selector: 'app-field-viewer',
  templateUrl: './field-viewer.component.html',
  styleUrls: ['./field-viewer.component.css']
})
export class FieldViewerComponent implements OnInit, OnChanges {

  @Output() refresh = new EventEmitter();
  @Input() Campi: CampoAggiuntivo[];
  @Output() CampiChange = new EventEmitter();
  @Input() DropdownSources: any = {};
  @Output() DropdownSourcesChange = new EventEmitter();
  @Input() Oggetto: any;
  @Output() OggettoChange = new EventEmitter();
  @Input() Padre: any;
  @Output() PadreChange = new EventEmitter();
  @Input() isModifyDisabled;
  @Input() hideLabel;
  @Input() CampiNascosti;
  @Output() OnFilter = new EventEmitter<{ OnFilter: string, Event: any }>();
  @Output() OnChange = new EventEmitter<{ OnChange: string, Event: any, CampoAggiuntivo?: CampoAggiuntivo, Oggetto?:any }>();
  @Input() Type: string;
  @Output() TypeChange = new EventEmitter();
  @Output() CustomButton = new EventEmitter();
  readonlyEditorConfig: AngularEditorConfig = {
    editable: false,
    enableToolbar: false,
    showToolbar: false,


  };
  signaturePadOptions: Object = {
    'minWidth': 5,
    'canvasWidth': 700,
    'canvasHeight': 200
  };
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    BgColor: '#FFFFFFF',
    toolbarHiddenButtons: [
    ]
  };
  blackEditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    sanitize:false,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    toolbarPosition: 'top',
    BgColor: 'black',
    toolbarHiddenButtons: [
    ]
  };


  constructor(
    public permission: Permission,
    public campoUtility: CampoUtility,
    public toastService: ToastrService,
    public apiPaths: ApiPathsService,
    private modalService: NgbModal,
    private appRef: ApplicationRef,
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.setupArrayDebouncer();
    this.Campi?.forEach(campo => {
      if (campo.type == 'Array' && (!this.IsArray(this.Oggetto[campo.oggetti[0]]) || !this.Oggetto[campo.oggetti[0]].length))
        this.Oggetto[campo.oggetti[0]] = ['']
      if(campo.type == 'Array')
        campo['subFields']=[{...campo, type: null, inputType: campo.inputType, nome: '', class: 'col-lg-12', oggetti:campo?.field?.length >1 ? ['data', 'data'] : ['data'], modificabile:false, field: campo.field }]
      if(campo.type == 'component')
        campo['injector'] = campo.func(this.Oggetto, this).injector;
      this.getSource(campo);
    })

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.DropdownSources && this.DropdownSources) {
      this.Campi?.forEach(campo => {
        this.getSource(campo);
      })
    }
    //console.log('changes', changes)
    if (changes.Oggetto) {
      this.Campi?.forEach(campo => {
        this.getSource(campo);
      })
    }
  }

  tableIndex(data: any[], item){
    return data.findIndex(x=> x == item)
  }

  tableData(data: any[], campo: CampoAggiuntivo){
   // console.log("tableData", campo)
    return campo.filter ? campo.filter(data) : data;
  }
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true })
  container: ViewContainerRef;
  createComponent(component): ComponentRef<any> {
    if (!this.container) {
      console.error('Container non inizializzato.');
      return;
    }
    return this.container.createComponent(component);
  }
  outletConfig(item: { component: any, params: any }) {
    const injector = Injector.create({
      providers: [
        // {
        //   provide: 'Offerta',
        //   useValue: item.params?.Offerta
        // }
      ],
      parent: this.injector
    });

    return {
      component: ListaInterventiOffertaComponent,
      injector
    };
  }
  RestCall(campo: CampoAggiuntivo, searchString?: string, urlField?: string ) {
    // console.log("RestCall", campo);
    // console.log("urlField", urlField);
    campo.searched = true;
    campo['runningUpdate'] = true;

    var filter: any = {};
    campo.parameter?.forEach(param => {
      var p = param?.parameter?.includes('.') ? param?.parameter?.split('.') : [param?.parameter];
      var parameter = Object.assign({}, this.Oggetto)
      p?.forEach(el => {
        parameter = this.getparam(parameter, el);
      })
      if (param.search)
        filter[param.nome] = searchString
      else if (param.func)
        filter[param.nome] = param.func(this.Oggetto, this.Padre);
      else
        filter[param.nome] = param?.value ?? parameter

    })
    console.log("parameter", campo.parameter);
    if (campo?.parameter && urlField ) {
      if(campo.settings && campo.settings.page && campo.settings.size && campo.settings.allowPagination) {
       filter = {...filter, size:campo.settings.size, page: campo.settings.page}
      }
      console.log("filterPost", filter);
      this.apiPaths.ClassicPost(campo[urlField], filter).subscribe(data => {
        this.onResponse(campo, data);
      })
    }
    else if (urlField && campo[urlField]) {
      this.apiPaths.ClassicGet(campo[urlField]).subscribe(data => {
        this.onResponse(campo, data);
      })
    }
  }

  getResponse(campo: CampoAggiuntivo, data: any){
    return campo.responseMap ? campo.responseMap(data, this.permission, this.Oggetto, this.Padre) : data
  }

  onResponse(campo: CampoAggiuntivo, data: any){
    if (campo.type == 'checkboxArray' || campo.type == 'checkboxArrayMEXC'  || campo.type == 'checkboxArrayOld') {
      this.getCheckBox(campo, data)
    } else if (campo.inputType == 'singleDropdown' || campo.inputType == 'multiselectDropdown' || campo.type == 'CategoriaNav' || campo.type == 'CategoriaNavHorizontal' || campo.type == 'calendar') {
      campo.source = (campo.responseHasData ? this.getResponse(campo, data.data) : this.getResponse(campo, data)) ?? [];
      if(campo.settings && campo.settings.page && campo.settings.size && campo.settings.allowPagination && campo.responseHasData) {
        campo.settings.totalpages = Math.ceil(data?.total / campo.settings.size);
      }
    } else {
      var arry = campo.responseHasData ? this.getResponse(campo, data.data) : this.getResponse(campo, data);
      if (arry.length > 1)
        arry[0].first = true;
      this.Oggetto[campo['oggetti'][0]] = arry;
    }
    if (campo.inputType == 'singleDropdown' && typeof campo.internalOutput == 'string' && !this.Oggetto[campo.internalOutput] && this.Oggetto[campo.OutputField] && Array.isArray(campo.source))
      this.Oggetto[campo.internalOutput] = campo.source?.find(x => x[campo.settings?.idField ?? 'id'] == this.Oggetto[campo.OutputField])
    if (campo.inputType == 'singleDropdown' && campo.source?.length == 1 && typeof campo.internalOutput == 'string' && campo.settings?.selectIfSingle)
      this.Oggetto[campo.internalOutput] = campo.source[0]
    if (campo.inputType == 'singleDropdown' && typeof campo.internalOutput == 'string' && campo.settings?.selectFirst)
      this.Oggetto[campo.internalOutput] = campo.source[0]
    setTimeout(()=>{campo['runningUpdate'] = false;}, 1000)

  }


  getCheckBox(campo: CampoAggiuntivo, source: any[]) {
    if (campo.type == 'checkboxArray' || campo.type == 'checkboxArrayMEXC' || campo.type == 'checkboxArrayOld') {

      var selected = Array.isArray(this.Oggetto[campo['oggetti'][0]]) ? [...this.Oggetto[campo['oggetti'][0]]] : [];
      console.log("selected:", selected)
      var selIds = selected.every(item => typeof item === "number") ? selected : selected?.filter(x => x.risposta)?.map(item => item.id);
      var data: { check?: string, id?: number, risposta?: boolean, fields?: CampoAggiuntivo[], codice: string }[] = source.map(check => {
        return {
          check: check.check ?? check.label,
          id: check.id,
          risposta: selIds?.find(x => x == check.id) != undefined,
          fields: this.mapCustomField(check),
          codice: check.codice
        }
      }) ?? [];

      this.Oggetto[campo['oggetti'][0]] = data
    }
  }
  GetJsonString(val){
    return JSON.stringify(val);
  }

  getSource(campo: CampoAggiuntivo, searchString?: string): any[] {
    if(campo['runningUpdate']) return [];
    if (
      (!campo.hideif?.fieldexist || !campo.hideif?.fieldnotexist || !campo.hideif?.fieldEqual || !campo.hideif?.fieldNotEqual || campo.modificabile == false)
      && (!this.campoUtility.Show(campo, this.Oggetto, true, this.Type)
        && !this.campoUtility.Show(campo, this.Oggetto, false, this.Type)) && !(campo.alwaysGetSource && campo.alwaysGetSource(this.Oggetto, this.permission))
    ) {
      return [];
    }

    if (typeof campo.source == 'string' && campo.source.includes('/'))
      this.RestCall(campo, searchString, 'source');
    else if (campo.type != "Files" && typeof campo.url == 'string' && campo.url?.includes('/'))
      this.RestCall(campo, searchString, 'url');
    else if (typeof campo.source == 'string' && campo?.sourceFilter) {
      campo.source = this.DropdownSources[campo.source]?.filter(x => !campo.sourceFilter || (
        (!campo.sourceFilter?.fieldexist || (typeof campo.sourceFilter?.fieldexist == 'string' && x[campo.sourceFilter?.fieldexist])) &&
        (!campo.sourceFilter?.fieldnotexist || (typeof campo.sourceFilter?.fieldnotexist == 'string' && !x[campo?.sourceFilter?.fieldnotexist])) &&
        (!campo?.sourceFilter?.arrayEmpty || (!x[campo?.sourceFilter?.arrayEmpty] || x[campo?.sourceFilter?.arrayEmpty]?.length >= 0)) &&
        (!campo?.sourceFilter?.arrayFull || x[campo?.sourceFilter?.arrayFull]?.length > 0) &&
        (!campo?.sourceFilter?.func || campo?.sourceFilter?.func(x, this.Oggetto, this.permission))
      ))
    }
    else if (campo.source && typeof campo.source != 'string') {
      campo.source = campo.source?.filter(x => !campo.sourceFilter ||
        ((!campo.sourceFilter?.fieldexist || x[campo.sourceFilter?.fieldexist]) &&
          (!campo.sourceFilter?.fieldnotexist || !x[campo?.sourceFilter?.fieldnotexist]) &&
          (!campo?.sourceFilter?.arrayEmpty || (!x[campo?.sourceFilter?.arrayEmpty] || x[campo?.sourceFilter?.arrayEmpty]?.length >= 0)) &&
          (!campo?.sourceFilter?.arrayFull || x[campo?.sourceFilter?.arrayFull]?.length > 0) &&
          (!campo?.sourceFilter?.func || campo?.sourceFilter?.func(x, this.Oggetto, this.permission))
        ))
    }

    var elements = !Array.isArray(campo.source) && this.DropdownSources ? this.DropdownSources[campo.source] : campo.source
    if (campo.inputType == 'singleDropdown' && typeof campo.internalOutput == 'string' && !this.Oggetto[campo.internalOutput] && this.Oggetto[campo.OutputField] && elements)
      this.Oggetto[campo.internalOutput] = elements?.find(x => x[campo.settings?.idField ?? 'id'] == this.Oggetto[campo.OutputField])
    if (campo.inputType == 'singleDropdown' && elements?.length == 1 && typeof campo.internalOutput == 'string' && campo.settings?.selectIfSingle)
      this.Oggetto[campo.internalOutput] = elements[0]
    if (campo.inputType == 'singleDropdown' && typeof campo.internalOutput == 'string' && campo.settings?.selectFirst && campo.source && !this.Oggetto[campo.internalOutput])
      this.Oggetto[campo.internalOutput] = elements[0]
    return elements;
  }

  getparam(oggetto, param) {
    return oggetto ? oggetto[param] : null;
  }

  mapCustomField(check: { check: string, id: number, fields: { label: string, name: string, type: 'number' | 'dropdown' | 'string', values: any[], tariffe?: { max?: number, min: number, prezzo: number }[] }[] }) {
    return check?.fields?.map(field => {
      const campo: CampoAggiuntivo = {
        nome: field.label,
        oggetti: [field.name],
        modificabile: true,
        OnChange: "getPrice",
        class: check.fields.length > 1 ? 'col-lg-6' : 'col-12',
        tariffe: field.tariffe
      }
      switch (field.type) {
        case 'dropdown':
          campo.inputType = 'singleDropdown';
          campo.source = field.values;
          campo.internalOutput = field.name;
          campo.OutputObject = field.name + "Object";
          campo.settings = {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'label',
          }

          break;
        case "number":
          campo.inputType = 'number';
          break;
        case "string":
          campo.inputType = 'text';
          break;
      }
      return campo
    })
  }

  IsArray(val) {
    return val && Array.isArray(val);
  }

  getObject(campo: CampoAggiuntivo, i: number) {
    var obj =
      this.getValue(this.Oggetto, campo, i)
    // console.log("Campo", campo)
    // console.log("Val", this.Oggetto[campo.oggetti[i]])
    //   console.log("Obj: ", obj)
    return obj;
  }
  public getValue(Oggetto, campo: CampoAggiuntivo, i: number) {
    if (campo.type == 'object' && Oggetto[campo.oggetti[i]] && Oggetto[campo.oggetti[i]][campo.field[i]] && typeof Oggetto[campo.oggetti[i]][campo.field[i]] !== 'string')
      return campo.field[i + 1] ? Oggetto[campo.oggetti[i]][campo.field[i]][campo.field[i + 1]] : {}
    else if (Oggetto[campo.oggetti[i]] && (campo.type == 'object' || (typeof Oggetto[campo.oggetti[i]] == 'object' && campo.field)))
      return Oggetto[campo.oggetti[i]][campo.field[i]]
    else
      return this.hasDot(campo.oggetti[i]) ?  this.dotValue(campo.oggetti[i], Oggetto) :  Oggetto[campo.oggetti[i]];
  }

  // getArraySubfieldOption(campo:CampoAggiuntivo):CampoAggiuntivo[]{
  //   return
  // }

  dotValue(param, oggetto) {
    var p = param?.split('.');
    var parameter = Object.assign({}, oggetto);
    p?.forEach(el => {
    parameter = this.getparam(parameter, el);
  })
  return parameter;
  }

  FilterHandler(campoAggiuntivo: CampoAggiuntivo, $event: any) {
    this.OnFilter.emit({ OnFilter: campoAggiuntivo.OnFilter, Event: $event })
    campoAggiuntivo.lastFilter = $event;
    if (campoAggiuntivo?.parameter?.some(x => x.search)) {
      this.getSource(campoAggiuntivo, $event)
    }
  }
  public static SendEmail(to?: string[], subject?: string, body?: string, cc?: string[], bcc?: string[]): void {
    const encodeParam = (param: string): string => encodeURIComponent(param);

    // Base del link mailto
    let mailto = "mailto:";

    // Aggiungere destinatari principali (to)
    if (to && to.length > 0) {
      mailto += to.join(",");
    }

    // Costruire i parametri query
    const params = new URLSearchParams();

    if (subject) params.append("subject", subject);
    if (body) params.append("body", body);
    if (cc && cc.length > 0) params.append("cc", cc.join(","));
    if (bcc && bcc.length > 0) params.append("bcc", bcc.join(","));

    // Aggiungere i parametri al link mailto
    const queryString = params.toString();
    if (queryString) {
      mailto += `?${queryString}`;
    }

    // Eseguire l'azione
    window.location.href = mailto;
  }
  sendMail(
    to?: string[],
    subject?: string,
    body?: string,
    cc?: string[],
    bcc?: string[]
  ): void {
  // Funzione per creare una stringa con i parametri del mailto
  FieldViewerComponent.SendEmail(to, subject, body, cc, bcc);
}

  More(x, campo, oggetto) {
    campo?.onMore(x, this.apiPaths, this.permission, campo,  (x) => {
      campo.source?.push(x);
      this.Oggetto[campo.internalOutput] = x;
    });
  }

  ChangeHandler(OnChange: string, $event: any, CampoAggiuntivo: CampoAggiuntivo, CampoPadre?: CampoAggiuntivo) {
    if(OnChange == 'mailTo'){
      var email = $event;
      this.sendMail(
        [email],
        "Ticket:" + this.Oggetto.id,
      );
    }
    if(OnChange == undefined && CampoAggiuntivo['func']){
      CampoAggiuntivo['func']( this.Oggetto, CampoAggiuntivo, CampoPadre, this.Padre, this.apiPaths, this);
      return;
    }
    //console.log('event',$event );
    if (CampoAggiuntivo.OutputField && this.Oggetto && !$event) {
      this.Oggetto[CampoAggiuntivo.OutputField] = null;
    }
    else if (CampoAggiuntivo.OutputField && this.Oggetto && $event) {
      this.Oggetto[CampoAggiuntivo.OutputField] = $event[CampoAggiuntivo?.settings?.idField ?? 'id'] ?? null;
      //console.log(`selected id: ${$event?.id} copied to ${CampoAggiuntivo.OutputField}: ${this.Oggetto[CampoAggiuntivo.OutputField]}`);
    }
    if (CampoAggiuntivo.OutputField && !CampoAggiuntivo?.settings?.singleOutput && !$event) {
      this.Oggetto[CampoAggiuntivo.OutputField] = null;
    }
    if (CampoAggiuntivo.OutputField && !CampoAggiuntivo?.settings?.singleOutput) {
      this.Oggetto[CampoAggiuntivo.OutputField] = $event?.map(x => CampoAggiuntivo?.settings?.idField ? x[CampoAggiuntivo?.settings?.idField ?? 'id'] : x.id) ?? null;
      //console.log(`selected ids: ${$event?.map(x=> x.id)} copied to ${CampoAggiuntivo.OutputField}: ${this.Oggetto[CampoAggiuntivo.OutputField]}`);
    }
    if (CampoAggiuntivo.OutputObject) {
      this.Oggetto[CampoAggiuntivo.OutputObject] = $event ?? null;
      //console.log(`selected value: ${$event} copied to ${CampoAggiuntivo.OutputObject}: ${this.Oggetto[CampoAggiuntivo.OutputObject]}`);
    }
    this.OnChange.emit({ OnChange: OnChange, Event: $event, CampoAggiuntivo: CampoPadre ?? CampoAggiuntivo, Oggetto: this.Oggetto })
    if (CampoAggiuntivo?.OnChangeFunc)
      CampoAggiuntivo.OnChangeFunc(this.Oggetto, $event, this.apiPaths, this.toastService);
    this.Campi?.forEach(campo => {
      this.getSource(campo);
    })

  }

  async filechange(OnChange, event, campoAggiuntivo: CampoAggiuntivo) {
    const file: Blob = event.target.files[0];
    this.SetFile(file, event.target.files[0].name, campoAggiuntivo)
  }
  async generateBase64Thumbnail(file: Blob): Promise<string> {
    const arrayBuffer = await file.arrayBuffer();
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale: 1.5 }); // Aumenta la qualità
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d')!;
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const renderContext = { canvasContext: context, viewport: viewport };
    await page.render(renderContext).promise;

    // 👉 Ottieni il base64
    return canvas.toDataURL('image/png'); // restituisce stringa base64
  }
  DeleteFile(campoAggiuntivo: CampoAggiuntivo) {
    if (campoAggiuntivo?.multipart) {
      this.Oggetto[campoAggiuntivo?.oggetti[0] ?? 'allegato'] = null;
      this.Oggetto[campoAggiuntivo.nameField ?? ((campoAggiuntivo?.oggetti[0] ?? '') + 'file')] = null;
    } else {
      if(!isNaN(this.Oggetto[campoAggiuntivo?.oggetti[0] ?? 'allegato'])){
        var to_del = Object.assign({},{file: this.Oggetto[campoAggiuntivo?.oggetti[0] ?? 'allegato'], thumb: campoAggiuntivo && campoAggiuntivo['anteprima']  ? this.Oggetto[campoAggiuntivo['anteprima']]: null })
        this.apiPaths.ClassicPost('/file/delete', {id: to_del.file}).subscribe(
          data=>{
            console.log("file eliminato",campoAggiuntivo, to_del);
            if(campoAggiuntivo && campoAggiuntivo['anteprima'] && !isNaN(to_del.thumb)){
              this.apiPaths.ClassicPost('/file/delete', {id: to_del.thumb}).subscribe(()=> {
                  this.Oggetto[campoAggiuntivo['anteprima']] = null
                  console.log("thumb eliminato",campoAggiuntivo, to_del);
                }
              )
            }

            this.Oggetto[campoAggiuntivo?.oggetti[0] ?? 'allegato'] = null;
            this.Oggetto[campoAggiuntivo.nameField ?? ((campoAggiuntivo?.oggetti[0] ?? '') + 'file')] = null;

          }
        );
      }else{
        this.Oggetto[campoAggiuntivo?.oggetti[0] ?? 'allegato'] = null;
        this.Oggetto[campoAggiuntivo.nameField ?? ((campoAggiuntivo?.oggetti[0] ?? '') + 'file')] = null;
        if (campoAggiuntivo && campoAggiuntivo['anteprima']) {
          console.log("Anteprima: ", campoAggiuntivo['anteprima']);
          this.Oggetto[campoAggiuntivo['anteprima']] = null;
        }
      }

    }
  }
  OpenFile(campoAggiuntivo: CampoAggiuntivo) {
    if(this.Oggetto[(campoAggiuntivo?.oggetti[0] ?? 'allegato')]){
      this.apiPaths.DownloadFileByUrl(this.apiPaths.getBaseAPI() +'/file/download/' + this.Oggetto[(campoAggiuntivo?.oggetti[0] ?? 'allegato')]);

    }
  }

  SetFile(file, filename, campoAggiuntivo: CampoAggiuntivo) {
    if (file.size > 78643200) {
      this.toastService.warning("Questo file è troppo grande per essere caricato.", "Attenzione!")
      return;
    } else {
      console.log("FileSize: ", file.size);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        if (reader.result.toString().length > 100) {
          if (campoAggiuntivo?.multipart) {
            this.Oggetto[campoAggiuntivo?.oggetti[0] ?? 'allegato'] = file;
            this.Oggetto[campoAggiuntivo.nameField ?? ((campoAggiuntivo?.oggetti[0] ?? '') + 'file')] = filename;
            console.log("File Salvato in ", campoAggiuntivo?.oggetti[0] ?? 'allegato', file)
          } else {
            this.SetBase64File(reader.result.toString(), filename, campoAggiuntivo);
            this.Oggetto[(campoAggiuntivo?.oggetti[0] ?? 'allegato') + 'FileObject'] = file;
            if (campoAggiuntivo && campoAggiuntivo['anteprima']) {
              console.log("Anteprima: ", campoAggiuntivo['anteprima']);
              this.Oggetto[campoAggiuntivo['anteprima']] = await this.generateBase64Thumbnail(file);
            }
          }
        } else{
          this.Oggetto.allegato = undefined;

        }


      };
    }
    this.OnChange.emit({ OnChange: campoAggiuntivo.OnChange, Event: file })
  }

  SetBase64File(file, filename, campoAggiuntivo: CampoAggiuntivo) {
    if ((file ?? '').length <= 100) return;
    this.Oggetto[campoAggiuntivo?.oggetti[0] ?? 'allegato'] = file;
    this.Oggetto[campoAggiuntivo.nameField ?? ((campoAggiuntivo?.oggetti[0] ?? '') + 'file')] = filename;
  }

  hasAzioni(azioni, fields) {
    return fields?.some(field => azioni?.some(azione => this.campoUtility.ButtonShow(azione, field)));
  }

  allSelected(headerField: any, data: any[]) {
    return data.every(x => this.campoUtility.getObject(headerField, x, 0));
  }

  toggleAll(headerField: any, data: any[]) {
    var oldValue = Object.assign({}, { val: this.allSelected(headerField, data) })
    data.forEach((x) => x[headerField.oggetti[0]] = !oldValue.val)
  }

  AddClick(campo: CampoAggiuntivo) {
    if (campo.AddClick) {
      campo.AddClick.emit()
    } else {
      this.OnChange.emit({ OnChange: campo.ExternalAddClick, Event: {} })
    }
  }

  GetImageID(id_immagine: any) {
    return id_immagine > 0 ? `${this.apiPaths.getBaseAPI()}/file/image/${id_immagine?.toString()}` : undefined;
  }
  async ImageChange(event, target, type: 'image' | 'pdf', filename?) {
    const blob: Blob = event.target.files[0];
    if (!blob.type.includes(type)) {
      this.toastService.warning("Questo formato non è supportato. Inserire solo " + type + ".", "Attenzione!")
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      this.Oggetto[target] = reader.result.toString().length > 1 ? reader.result.toString() : undefined;
      if (!filename) return;
      this.Oggetto[filename] = reader.result.toString().length > 1 ? event.target.files[0].name : this.Oggetto[filename];
    };
  }
  onImageError(prodotto: Prodotto) {
    // prodotto.UrlImmagine = 'assets/images/gallery/NoImageAvailable.png';
  }

  drawComplete(campo: any, pad: SignaturePad) {
    var value = pad.toDataURL("image/png");
    this.SetBase64File(value, `Firma-${this.Oggetto?.id?.toString()}`, campo)
  }
  cancellaFirma(pad: SignaturePad) {
    pad.clear();
  }



  CreateParams(param: any, Oggetto: any) {
    var newTask = {};
    param?.concat?.forEach(concatObj => {
      var p = concatObj.from?.split('.');
      var parameter = Object.assign({}, Oggetto)
      p?.forEach(el => {
        parameter = this.getparam(parameter, el);
      })// TODO: gestire array meglio!!

      newTask[concatObj.to] = newTask[concatObj.to] ? newTask[concatObj.to] + parameter : parameter;
    });
    param?.copy?.forEach(concatObj => {
      if (concatObj.from)
        newTask[concatObj.to] = Oggetto[concatObj.from];
      else if (concatObj.value)
        newTask[concatObj.to] = concatObj.value;
    });
    return newTask;
  }

  toggleDay(oggetto, param) {
    this.campoUtility.getObj(this.Oggetto, oggetto)[param] = !this.campoUtility.getObj(this.Oggetto, oggetto)[param];
  }


  getHeadField(headField, campo: CampoAggiuntivo) {
    var _headField = Object.assign({}, headField);
    _headField.modificabile = headField.modificabile && !this.campoUtility.Disable(campo, this.Oggetto)
    return _headField
  }

  Disable(campo, Oggetto) {
    if(this.Padre)
      Oggetto.Figlio = {...this.Oggetto, figlio: undefined};
    return this.isModifyDisabled || this.campoUtility.Disable(campo, Oggetto);
  }
  customButton(oggetti, button: ActionButton) {
    if (button.func)
      button.func(this.Oggetto, this.apiPaths, () => {if (button.close) this.modalService.dismissAll(); else if(button.refresh) this.refresh.emit(); }, this.toastService)
    else
      this.CustomButton.emit(button);
  }
  customAction(oggetti, button) {

    this.CustomButton.emit(button);
  }
  bottonEdit(field, bottone, campo) {
    const EditModal = this.modalService.open(DynamicEditComponent, {
      centered: true,
      backdrop: 'static',
      container: '#main-wrapper',
      size: 'xl'
    });
    (<DynamicEditComponent>EditModal.componentInstance).CrudSettings = bottone.CrudSettings;
    (<DynamicEditComponent>EditModal.componentInstance).Item = field ?? {};
    (<DynamicEditComponent>EditModal.componentInstance).ExternalSave = bottone.ExternalSave != false && !(!bottone.onlyUpdate || field?.id );
    (<DynamicEditComponent>EditModal.componentInstance).updated.subscribe(data => {
      this.refresh.emit(data);
    });
  }

  hasDot(oggetto:string){
    return oggetto.includes('.')? oggetto.split('.')?.length : 0;
  }
  OggettoDot(oggetto:string, pos:number){
    return oggetto.split('.')[pos];
  }

  OggettoArrayChange(event, oggetto, indice) {
    this.searchDecouncer$.next({event, oggetto, indice});
  }
  private searchDecouncer$: Subject<any> = new Subject();

  private setupArrayDebouncer(): void {
    this.searchDecouncer$.pipe(
      debounceTime(1250),
    ).subscribe((term: any) => {
      this.Oggetto[term.oggetto][term.indice] = term.event.Event;
    });
  }

  onLoadPage(campo:CampoAggiuntivo, operation?: '-'|'+') {
    if(operation == '-') {
      campo.settings.page = (campo.settings.page ?? 0) - 1;
    }
    else {
      campo.settings.page = (campo.settings.page ?? 0) + 1;

    }
    console.log("Page load: ",campo.settings.page);
    this.FilterHandler(campo,campo.lastFilter)
  }

  protected readonly ca = ca;
  protected readonly isNaN = isNaN;
}
